var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1377_25534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6676 10.6665L8.00095 7.99983M8.00095 7.99983L5.33428 10.6665M8.00095 7.99983V13.9998M13.5943 12.2598C14.2445 11.9053 14.7582 11.3444 15.0542 10.6656C15.3502 9.98674 15.4118 9.22865 15.2291 8.51095C15.0464 7.79326 14.6299 7.15683 14.0454 6.70212C13.4609 6.24741 12.7415 6.00032 12.0009 5.99983H11.1609C10.9592 5.21932 10.5831 4.49472 10.0609 3.88049C9.53877 3.26626 8.88418 2.77839 8.14635 2.45356C7.40852 2.12874 6.60665 1.9754 5.80103 2.00508C4.99541 2.03476 4.20699 2.24669 3.49507 2.62494C2.78314 3.00318 2.16622 3.5379 1.6907 4.18888C1.21517 4.83987 0.89341 5.59018 0.749603 6.38342C0.605797 7.17666 0.643687 7.99218 0.860426 8.76867C1.07716 9.54515 1.46711 10.2624 2.00095 10.8665",
    stroke: "#1E1E1E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1377_25534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/Cloud.de4994e89f4e80f140d8d1a93eae7b59.svg";
export { ForwardRef as ReactComponent };